import { render, staticRenderFns } from "./TrainingPlan.vue?vue&type=template&id=60f69615&"
import script from "./TrainingPlan.vue?vue&type=script&lang=js&"
export * from "./TrainingPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports